import { Container, Skeleton } from "@crehana/ui";
import { MentorsListSkeleton } from "../MentorsList";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MentorsSkeleton = function MentorsSkeleton(_ref) {
  var isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Skeleton, {
      className: "w-48 h-16 mb-8",
      isDark: isDark
    }), /*#__PURE__*/_jsx(Skeleton, {
      className: "w-3/4 sm:w-360 h-24 mb-16",
      isDark: isDark
    }), /*#__PURE__*/_jsx(Skeleton, {
      className: "w-2/4 sm:w-280 h-20 mb-24",
      isDark: isDark
    }), /*#__PURE__*/_jsx(MentorsListSkeleton, {
      isDark: isDark
    })]
  });
};
export default MentorsSkeleton;